import { useReducer } from 'react';

import { Order } from 'src/models';

import { SinglePageModal } from '../MModal/SinglePageModal';

import { ChangeOrderFailedStep } from './ChangeOrderFailedStep';
import { ChangeOrderStep, ChangeOrderFormValues } from './ChangeOrderStep';
import { ChangeOrderSucceededStep } from './ChangeOrderSucceededStep';

enum ChangeOrderStepName {
  Change = 'Change',
  Succeeded = 'Succeeded',
  Failed = 'Failed',
}

interface ChangeOrderReducerState extends ChangeOrderFormValues {
  step: ChangeOrderStepName;
}

type ChangeOrderReducerAction = { type: 'UPDATE'; payload: Partial<ChangeOrderReducerState> };

const changeOrderReducer = (state: ChangeOrderReducerState, action: ChangeOrderReducerAction) => {
  switch (action.type) {
    case 'UPDATE':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

interface ChangeOrderModalProps {
  open: boolean;
  order: Order;
  accountId: number;
  onClose: () => void;
}

export const ChangeOrderModal = ({ open, order, accountId, onClose }: ChangeOrderModalProps) => {
  const [orderState, orderDispatch] = useReducer(changeOrderReducer, {
    step: ChangeOrderStepName.Change,
    price: order.limit,
    stop: order.stop,
  });

  const renderModal = () => {
    if (orderState.step === ChangeOrderStepName.Succeeded) {
      return {
        width: 600,
        onClose,
        content: <ChangeOrderSucceededStep onClose={onClose} />,
      };
    }

    if (orderState.step === ChangeOrderStepName.Failed) {
      return {
        width: 600,
        onClose,
        content: (
          <ChangeOrderFailedStep
            order={order}
            values={{ price: orderState.price, stop: orderState.stop }}
            onClose={onClose}
          />
        ),
      };
    }

    return {
      width: 600,
      onClose,
      content: (
        <ChangeOrderStep
          order={order}
          accountId={accountId}
          initialValues={{ price: orderState.price, stop: orderState.stop }}
          onClose={onClose}
          onSuccess={values => {
            orderDispatch({ type: 'UPDATE', payload: { ...values, step: ChangeOrderStepName.Succeeded } });
          }}
          onError={values => {
            orderDispatch({ type: 'UPDATE', payload: { ...values, step: ChangeOrderStepName.Failed } });
          }}
        />
      ),
    };
  };

  return <SinglePageModal open={open} testId='change-order' {...renderModal()} />;
};
